import ToggleButton from 'Components/Common/components/Inputs/ToggleButton';
import React, { FC } from 'react'

interface MoreDetailsProps {
    min_ad_price: string;
    upc: string;
    normalized_min_ad_price: string;
    image_flag: boolean;
    long_description: boolean;
}

const MoreDetails: FC<MoreDetailsProps> = ({min_ad_price, upc, normalized_min_ad_price, image_flag, long_description}) => {
  return (
    <React.Fragment>
        <h3 className={`tw-mt-3 tw-ms-1 tw-text-sm`}>More Details</h3>
          <div className={`tw-flex tw-flex-wrap tw-justify-start tw-py-2`}>
            <div className={`tw-w-1/3 tw-p-1`}>
                <h2 className={`tw-text-sm`}>{"Min AD Price"}</h2>
                <h4 className={`tw-text-xs tw-mt-1 tw-text-[#5C5F62]`}>{min_ad_price?.toString() ?? "---"}</h4>
            </div>

            <div className={`tw-w-1/3 tw-p-1`}>
              <h2 className={`tw-text-sm`}>{"UPC"}</h2>
              <h4 className={`tw-text-sm tw-mt-1 tw-text-[#5C5F62]`}>{upc?.toString() ?? "---"}</h4>
            </div>

            <div className={`tw-w-1/3 tw-p-1`}>
              <h2 className={`tw-text-sm`}>{"Normalized Min AD Price"}</h2>
              <h4 className={`tw-text-sm tw-mt-1 tw-text-[#5C5F62]`}>{ normalized_min_ad_price?.toString() ??"---"}</h4>
            </div>
          </div>
    </React.Fragment>
  )
}

export default MoreDetails